const getSelectedVoucher = (vouchers = [], loyaltyCampaignId) => {
    return vouchers.length
        ? vouchers.find((item) => item.campaign_id === loyaltyCampaignId)
        : undefined;
};
export default getSelectedVoucher;
//# sourceMappingURL=getSelectedVoucher.js.map